import React, { useState, ReactElement, useEffect } from "react";
import { RiArticleLine } from "react-icons/ri";
import SearchBar from "../search-bar/SearchBar";
import { Link, Paths } from "../../contexts/Routing";
import { useListArticlesQuery } from "../../__generated__/api";
import { NoDataOrError } from "../../pages/error/Error";
import Styles from "./ArticleTags.module.scss";
import { HtmlRenderer } from "../html-render/HtmlRenderer";

interface ArticleTagsSearchProps {
    onSearching: () => void;
    onDoneSearching: () => void;
}

export default function ArticleTagsSearch({ onSearching, onDoneSearching }: ArticleTagsSearchProps): ReactElement {
    const [searchTerm, setSearchTerm] = useState<string>("");
    const { error, loading: isLoading, data } = useListArticlesQuery({
        skip: !searchTerm,
        variables: {
            query: searchTerm,
            limit: 5,
        },
    });

    const articles = data?.articles?.results;
    const results = articles?.dedupe(article => article.id) ?? [];

    useEffect(() => {
        if (searchTerm) {
            onSearching?.();
        } else {
            onDoneSearching?.();
        }
    }, [searchTerm]);

    if (error) {
        return <NoDataOrError error={error} />;
    }

    return (
        <>
            <SearchBar
                onChange={setSearchTerm}
                className="form-control-sm form-control fs-6"
                isLoading={isLoading}
            />
            {results.map(article => (
                <Link
                    key={article.id}
                    to={Paths.ANSWERS_GET}
                    params={{
                        id: article.id,
                    }}
                    search={{
                        search: searchTerm,
                    }}
                    className={"list-group-item list-group-item-action list-border "
                                + "list-border-default list-border-primary-hover flex-row d-flex mb-3 py-0 ps-2"}
                >
                    <div className="me-2 text-center">
                        {article.iconUrl ? (
                            <img
                                src={article.iconUrl as string}
                                alt="Article icon"
                                className={`w-100 ${Styles.icon}`}
                            />
                        ) : (
                            <RiArticleLine className="fs-5" />
                        )}
                    </div>
                    <div className="flex-column d-flex h-100 w-100">
                        <strong className="mb-1 font-weight-bold">{article.title}</strong>
                        <HtmlRenderer className={Styles["preview-text"]} html={article.previewText as string} />
                    </div>
                </Link>
            ))}
            {results?.isEmpty && !isLoading && searchTerm && <p className="text-gray-500">No articles match your search.</p>}
        </>
    );
}
